import type { AnalyticsLot, AnalyticsStore } from '~/analytics/composables-types'
import type { AmplitudePayloadResult } from '~/analytics/composables-types'
import { getGlobalPreviewCatalog } from '~/analytics/composables-types'
import {
  appendLotProductOwnerFields,
  getProductPageSourceFields,
} from '~/composables/useLotProductAnalytics'

interface ViewRatesParams {
  store: AnalyticsStore
  lot?: AnalyticsLot | null
}

export function getViewRatesAmplitudePayload ({
  store,
  lot,
}: ViewRatesParams): AmplitudePayloadResult {
  if (!lot) {
    return {}
  }

  const payload: AmplitudePayloadResult = {
    ...getProductPageSourceFields(lot),
  }

  return appendLotProductOwnerFields(payload, {
    rootGetters: store.getters,
    lot,
    owner: lot.user,
    productList: getGlobalPreviewCatalog(),
  })
}
